// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"6b90b273","252":"6f01c74e","641":"ba27bc78"}[chunkId] + ".chunk.css";
};